import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Articulo } from "@/shared/types/articulo";
import { getImage } from "./get-image";

export async function getArticulo(id: string, includeImage: boolean = false): Promise<Articulo> {
    await sleep(1000);
    const response = await api.get<Articulo>("articulos/" + id);
    if (response.data && includeImage) response.data.imagen = await getImage(id);
    return response.data;
}

export function useGetArticuloQuery(id: string, includeImage: boolean = false, queryConfig: QueryConfig<Articulo> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getArticulo(id, includeImage),
        queryKey: ["articulos", id],
    })
}

export interface GetArticuloQueryProps {
    id: string,
    includeImage?: boolean,
    queryConfig?: QueryConfig<Articulo>,
    children?: (queryResult: QueryResult<Articulo>) => ReactNode
}

export function GetArticuloQuery({
    id,
    includeImage = false,
    children,
    queryConfig
}: GetArticuloQueryProps) {
    const queryResult = useGetArticuloQuery(id, includeImage, queryConfig);
    return children && children(queryResult);
}